module.exports = __webpack_public_path__ + "img/map-preview.98a8af88.webp";